import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json"
import { AprobarSolicitudesHEDTO, solicitudesUnidad } from "../Revisar Solicitudes Horas Extras/typesAprobarSolicitudHE";
import { authHeader, authHeaderWithUserData } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import axios from "axios";
import { authenticationService } from "services/authentication.service";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { DetalleRegimenUnidad } from "../Ejecucion Presupuestaria HE/typeHistoricoUnidadesHE";
import { downloadExcelReport } from "helpers/downloadExcelReport";

const URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH = `${configData.SERVER_URL}HistorialSolicitudesTH/`

export async function obtenerSolicitudesRev( mes: Number, anio: number ) {
    var respuesta: ResponseRequestGeneric<AprobarSolicitudesHEDTO[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}SolicitudesReversar/${mes}/${anio}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: AprobarSolicitudesHEDTO[] | undefined = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<AprobarSolicitudesHEDTO[]>(error)
    }
    return respuesta
    
}

export async function obtenerSolicitudesAp( mes: Number, anio: number, idEstructura: number) {
    var respuesta: ResponseRequestGeneric<AprobarSolicitudesHEDTO[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}HistorialAprobadas/${mes}/${anio}/${idEstructura}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: AprobarSolicitudesHEDTO[] | undefined = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<AprobarSolicitudesHEDTO[]>(error)
    }
    return respuesta
    
}

export async function obtenerSolicitudesRP( mes: Number, anio: number, idEstructura: number) {
    var respuesta: ResponseRequestGeneric<AprobarSolicitudesHEDTO[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}HistorialRechazadas/${mes}/${anio}/${idEstructura}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: AprobarSolicitudesHEDTO[] | undefined = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<AprobarSolicitudesHEDTO[]>(error)
    }
    return respuesta
    
}

export async function unidadesHistorica( mes: Number, anio: number, isAprobada: boolean) {
    var respuesta: ResponseRequestGeneric<solicitudesUnidad[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}UnidadesHistorial/${mes}/${anio}/${isAprobada}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: solicitudesUnidad[] | undefined = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<solicitudesUnidad[]>(error)
    }
    return respuesta
    
}

export async function ReversarSolicitudes(solicitudes: AprobarSolicitudesHEDTO[]){
    const url = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}ReversarSolicitudes`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url,solicitudes,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        infoResponse = {
            status: respuesta.status
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}


export async function historicoMovUnidades() {
    var respuesta: ResponseRequestGeneric<DetalleRegimenUnidad[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}HistorialMovimientosUnidadHE`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: DetalleRegimenUnidad[] | undefined = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<DetalleRegimenUnidad[]>(error)
    }
    return respuesta
    
}

export async function ObtenerReporteExcelEjecucionPHE() {
    var respuesta: ResponseRequestGeneric<string> = {
        status: -1
    }
    const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}ReporteEjecucionPresupuestoTH`;
    const url = 'HistorialSolicitudesTH/ReporteEjecucionPresupuestoTH';
    try {
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: DetalleRegimenUnidad | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
        await downloadExcelReport(url, "REPORTE EJECUCIÓN PRESUPUESTARIA HORAS EXTRAS.xlsx");
    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<string>(error)
    }
    return respuesta;
}

export async function ObtenerReporteDetalladoEjecucionPHE(fechaDesde: string, fechaHasta: string) {
    var respuesta: ResponseRequestGeneric<string> = {
        status: -1
    }
    const URL_COMPLETA = `${URL_CONTROLLER_HISTORIAL_SOLICITUDES_TH}ReporteDetalladoPresupuesto/${fechaDesde}/${fechaHasta}`;
    const url = `HistorialSolicitudesTH/ReporteDetalladoPresupuesto/${fechaDesde}/${fechaHasta}`;
    try {
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: DetalleRegimenUnidad | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
        await downloadExcelReport(url, "REPORTE DETALLADO EJECUCIÓN PRESUPUESTARIA HORAS EXTRAS.xlsx");
    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<string>(error)
    }
    return respuesta;
}